import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneTestimonial, updateTestimonial } from 'slice/testimonialSlice';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Update = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, oneData } = useSelector((state) => state.testimonial);

    const [formData, setFormData] = useState({
        clientName: '',
        description: '',
        testimonialDate: '',
        rating: 5,
        status: 1
    });
    const [photo, setPhoto] = useState(null);

    useEffect(() => {
        dispatch(getOneTestimonial(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (oneData) {
            setFormData({
                clientName: oneData.clientName || '',
                description: oneData.description || '',
                testimonialDate: oneData.testimonialDate || '',
                rating: oneData.rating || 5,
                status: oneData.status ?? 1
            });
        }
    }, [oneData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setPhoto(e.target.files[0]);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = new FormData();
        Object.entries(formData).forEach(([key, val]) => data.append(key, val));
        if (photo) data.append('clientPhoto', photo);

        dispatch(updateTestimonial({ id, data }));
        toast.success('Testimonial updated successfully!');
        setTimeout(() => navigate('/khajuraho/testimonials'), 1500);
    };

    const getImageUrl = (img) => {
        if (!img) return '';
        const backend = process.env.REACT_APP_BACKEND || 'http://localhost:8001/';
        const base = backend.endsWith('/') ? backend : backend + '/';
        return `${base}uploads/${img.trim()}`;
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Update Testimonial</h4>
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className="row">
                    <div className="col-sm-6 mt-2">
                        <label htmlFor="clientName" className="adminlables">Client Name</label>
                        <input type="text" id="clientName" name="clientName" value={formData.clientName} className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-sm-3 mt-2">
                        <label htmlFor="rating" className="adminlables">Rating (1-5)</label>
                        <input type="number" id="rating" name="rating" min="1" max="5" value={formData.rating} className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-sm-3 mt-2">
                        <label htmlFor="testimonialDate" className="adminlables">Date</label>
                        <input type="date" id="testimonialDate" name="testimonialDate" value={formData.testimonialDate} className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="description" className="adminlables">Description</label>
                        <textarea rows={4} id="description" name="description" value={formData.description} className="form-control" onChange={handleChange} required></textarea>
                    </div>
                    <div className="col-sm-6 mt-4">
                        <label htmlFor="clientPhoto" className="adminlables">Client Photo (Optional)</label>
                        <input type="file" id="clientPhoto" className="form-control filebg" onChange={handleFileChange} />
                        {oneData?.clientPhoto && (
                            <div className="mt-2">
                                <img src={getImageUrl(oneData.clientPhoto)} alt="" width={100} className="rounded shadow-sm" />
                            </div>
                        )}
                    </div>
                    <div className="col-sm-6 mt-4">
                        <label htmlFor="status" className="adminlables">Status</label>
                        <select id="status" name="status" value={formData.status} className="form-control" onChange={handleChange}>
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                        </select>
                    </div>
                </div>
                <div className="mt-5 text-right">
                    <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
                        {loading ? 'Updating...' : 'Update Testimonial'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Update;
